

export const frontMatter = {};
export const contentTitle = undefined;



import {jsx as _jsx} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  return _jsx("table", {
    children: _jsx("thead", {
      children: _jsx("tr", {
        children: _jsx("th", {
          align: "center",
          lang: "isv-Latn-x-etymolog",
          children: " Ę Ų Å Ė Ȯ   Ć Đ   Ĺ Ń Ŕ T́ D́ Ś Ź"
        })
      })
    })
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

